// Workspace currency for money formatting.
//
// Resolution order: the active workspace's `settings.currency` → the build's
// default (from /app-config, e.g. INR for the furnishing installer) → USD.
//
// `formatCellValue` / layout code isn't a React component, so it can't read a
// hook or context. AppLayout keeps this module-level code in sync with the
// active workspace via `setActiveCurrency`, and the formatters read it.

let _code = "USD";

export const setActiveCurrency = (code) => { if (code) _code = String(code).toUpperCase(); };
export const activeCurrency = () => _code;

/** Format a number as money in the active (or given) currency. Non-numbers pass through. */
export function formatMoney(value, code = _code) {
  if (typeof value !== "number" || Number.isNaN(value)) return value;
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency: code }).format(value);
  } catch {
    // Invalid/unknown ISO code — fall back to a plain number with the code.
    return `${code} ${value.toLocaleString()}`;
  }
}

/** The bare currency symbol for the active (or given) currency, for input prefixes. */
export function currencySymbol(code = _code) {
  try {
    const parts = new Intl.NumberFormat(undefined, { style: "currency", currency: code }).formatToParts(0);
    return parts.find((p) => p.type === "currency")?.value || code;
  } catch {
    return code;
  }
}

// Common currencies offered in the workspace settings picker.
export const CURRENCIES = [
  { code: "INR", label: "₹  Indian Rupee (INR)" },
  { code: "USD", label: "$  US Dollar (USD)" },
  { code: "EUR", label: "€  Euro (EUR)" },
  { code: "GBP", label: "£  British Pound (GBP)" },
  { code: "AED", label: "د.إ  UAE Dirham (AED)" },
  { code: "AUD", label: "$  Australian Dollar (AUD)" },
  { code: "CAD", label: "$  Canadian Dollar (CAD)" },
  { code: "SGD", label: "$  Singapore Dollar (SGD)" },
];
